// extracted by mini-css-extract-plugin
export var actions = "_lf-g";
export var benefitCard = "_lf-b";
export var benefitIcon = "_lf-d";
export var benefitLabel = "_lf-f";
export var benefits = "_lf-a";
export var benefitsSection = "_lf-8";
export var bodyText = "_lf-7";
export var closeButton = "_lf-2";
export var content = "_lf-3";
export var eyebrow = "_lf-4";
export var heading = "_lf-5";
export var image = "_lf-i";
export var imagePanel = "_lf-h";
export var modal = "_lf-0";
export var offerCard = "_lf-c";
export var offerIcon = "_lf-e";
export var sectionLabel = "_lf-9";
export var shell = "_lf-1";
export var title = "_lf-6";